import smartSolveApi from './instances/smartsolve';

export const getUICacheObjects = async () => {
  try {
    const response = await smartSolveApi.post('/getUICacheObjects', {});
    return response.data;
  } catch (e) {
    throw new Error(`getUICacheObjects() failed: ${e}`);
  }
};
